import { motion } from "motion/react";
import React from "react";

export function FilterChips(props: {
  filterChips: React.ReactNode | undefined;
}) {
  return (
    <motion.div
      style={{
        maxHeight: "2.6em",
        minWidth: 0,
        flexShrink: 1,
        flexGrow: 1,
        overflowY: "auto",
      }}
      whileHover={{
        maxHeight: "5em",
      }}
      transition={{
        type: "spring",
        delay: 0.2,
        stiffness: 100,
      }}
    >
      {props.filterChips}
    </motion.div>
  );
}
